module.exports = __webpack_public_path__ + "app-static/img/bzz.72b2fea4.png";